import * as core from '../../../../../../../core'
import * as stakeholderAnalysis from '../stakeholder-analysis'

export const RESOURCE = {
  payload: {
    alias: 'dashboard',
    appAlias: stakeholderAnalysis.RESOURCE.payload.alias,
    description: 'Explore an overview of the stakeholders for this client',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Dashboard',
    page: { alias: 'stakeholder.analysis.dashboard' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
